export const FAMILY_SIZES: { value: number; text: string }[] = [
  { value: 2, text: "Liten familie (1-2)" },
  { value: 5, text: "Mellomstor familie (3-5)" },
  { value: 100, text: "Stor familie (6+)" },
];
